(function () {
  if (
    !(
      typeof window.CustomEvent === "function" ||
      typeof window.Event === "function"
    )
  ) {
    window.Event = window.CustomEvent = function (event, params) {
      params = params || { bubbles: false, cancelable: false, detail: null };
      const evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      return evt;
    };
  }
  if (!global.Intl) {
    import("intl").then(() => import("intl/locale-data/jsonp/en"));
  }

  if (!window.IntersectionObserver) {
    import("intersection-observer");
  }

  (function (doc, proto) {
    try {
      // check if browser supports :scope natively
      doc.querySelector(":scope body");
    } catch (err) {
      // polyfill native methods if it doesn't
      ["querySelector", "querySelectorAll"].forEach(function (method) {
        let nativ = proto[method];
        proto[method] = function (selectors) {
          if (/(^|,)\s*:scope/.test(selectors)) {
            // only if selectors contains :scope
            let id = this.id; // remember current element id
            this.id = "ID_" + Date.now(); // assign new unique id
            selectors = selectors.replace(/((^|,)\s*):scope/g, "$1#" + this.id); // replace :scope with #ID
            let result = doc[method](selectors);
            this.id = id; // restore previous id
            return result;
          } else {
            return nativ.call(this, selectors); // use native code for other selectors
          }
        };
      });
    }
  })(window.document, Element.prototype);
})();
